<script setup>
import { ref, onMounted, watch } from 'vue'
import axios from 'axios'

const words = ref([])
const userAnswers = ref({})
const correctAnswers = ref({})
const inputRefs = ref({})
const hintCounts = ref({})

onMounted(async () => {
  try {
    const response = await axios.get('/api/flashCard')
    words.value = response.data
    words.value.forEach(word => {
      userAnswers.value[word.id] = ''
      correctAnswers.value[word.id] = false
      inputRefs.value[word.id] = null
      hintCounts.value[word.id] = 0
    })
  } catch (error) {
    console.error(error)
  }
})

watch(userAnswers, async (newValues, oldValues) => {
  console.log(userAnswers.value, newValues, oldValues)

  for (const id in newValues) {
    if (!oldValues || oldValues[id] === undefined) continue // 初回実行時の `oldValues` を適切に処理

    const index = words.value.findIndex(w => w.id == id)
    if (index === -1) continue // 該当する単語がなければスキップ
    const word = words.value.find(w => w.id == id)
    if (!word) continue // 該当する単語がなければスキップ

    // 正解判定
    if ((newValues[id]?.trim().toLowerCase() || '') === word.word.toLowerCase()) {
      correctAnswers.value = { ...correctAnswers.value, [id]: true }
      console.log(`正解: ${word.word}`)

      // ✅ 正解した単語を一番下に移動
      setTimeout(() => {
        words.value.splice(index, 1) // 既存の位置から削除
        words.value.push(word) // 配列の末尾に追加
      }, 800)
      
    } else {
      correctAnswers.value = { ...correctAnswers.value, [id]: false }
    }
  }
}, { deep: true })

const showHint = (id) => {
  const word = words.value.find(w => w.id == id)
  if (word) {
    // 現在入力されている正解部分を保持
    const currentInput = userAnswers.value[id] || ''
    const correctPart = word.word.slice(0, currentInput.length) // すでに入力された部分

    // ヒントを1文字追加
    if (correctPart === word.word.slice(0, hintCounts.value[id])) {
      hintCounts.value[id] = Math.min(hintCounts.value[id] + 1, word.word.length)
    }

    // 更新したヒントを `v-text-field` に適用
    userAnswers.value[id] = word.word.slice(0, hintCounts.value[id])
  }
}
</script>

<template>
<v-container>
  <v-row v-for="word in words" :key="word.id">
    <v-col cols="12">
      <v-card class="pa-3">
        <v-row align="center">
          <v-col cols="8">
            <v-card-title>
              {{ word.meaning }}
            </v-card-title>
          </v-col>
          <v-col cols="4" class="text-right">
            <p v-if="correctAnswers[word.id]" class="text-success">正解！🎉</p>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="10">
            <v-text-field
              v-model="userAnswers[word.id]"
              label="単語を入力"
              outlined
              dense
              :ref="el => inputRefs[word.id] = el"
              autocapitalize="off"
              />
          </v-col>
          <v-col cols="2" class="text-right">
            <v-btn @click="showHint(word.id)" icon variant="text">
              <v-icon>mdi-lightbulb-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<style>
html, body {
  touch-action: manipulation;
}

.text-success {
  color: green;
  font-weight: bold;
}
</style>
